export default "__VITE_ASSET__DeOfKK6b__"